export default "__VITE_ASSET__DwzN_cky__"